module.exports = __webpack_public_path__ + "static/media/credit-card.8ed0b15c.svg";